'use strict';

var _bootstrap = require('./bootstrap.js');

(0, _bootstrap.bootstrap)();
//# sourceMappingURL=main.js.map
